import classNames from 'classnames';
import Divider from '@/components/common/Divider';
import ToDoList from '@/app/Crawl/components/pages/details/IssueToDoList';
import NoHeaderAgGridSkeleton from '@/app/common/components/skeleton/NoHeaderAgGridSkeleton';
import countSuffix from '@/helpers/countSuffix';
import { checkListConfig } from '@/app/Crawl/config/checkListConfig';
import { Col, Form, Row } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import { useGetUserInfoQuery } from '@/app/common/api/authApi';
import { useGetPageIssuesQuery } from '@/app/Crawl/api/detailsApi';
import IconAlert from '@/components/common/IconAlert';
import { decoder } from '@/helpers/utils';
import useDomain from '@/hooks/useDomain';
// موارد در جزییات صفحه
type ChecklistMode = 'danger' | 'warning' | 'info';

type Issue = {
  flag: string;
  count?: number | string;
};

type ChecklistItem = {
  title: string;
  show_title?: string;
};

type ChecklistConfig = {
  errors: ChecklistItem[];
  warning: ChecklistItem[];
  info: ChecklistItem[];
};

type PageIssuesResponse = {
  data?: {
    rows?: Issue[];
  };
};

const Issues = () => {
  const [searchParams] = useSearchParams();
  const { domain_slug } = useDomain();
  useGetUserInfoQuery();
  const { data: rawData, isLoading } = useGetPageIssuesQuery({
    job_page: searchParams.get('job_page'),
    domain_slug,
    page_url: decoder(searchParams.get('page_url') as string)
  });
  const data = rawData as PageIssuesResponse | undefined;

  return (
    <div id="issues" className="mt-5">
      {!isLoading && data ? (
        <>
          <IconAlert show={true} dismissible variant="info" className="my-4">
            این چک لیست صرفا برای مدیریت پروژه شما هست و تیک زدن آن به منزله ی
            رفع خطاها و هشدارها توسط ابزار نیست.
          </IconAlert>
          <Row>
            <Col md={4}>
              <ToDoList
                //بخش خطا ها
                data={data?.data?.rows?.filter(
                  (issue: Issue) =>
                    issue.flag !== 'error' &&
                    issue.flag !== 'warning' &&
                    issue.flag !== 'info'
                )}
                mode="danger"
                numOfIssue={countSuffix(
                  data?.data?.rows?.find(
                    (issue: Issue) => issue.flag === 'error'
                  )?.count
                )}
                title="خطا"
                tooltip="eererer"
                job_page={searchParams.get('job_page')}
                page_url={decoder(searchParams.get('page_url') as string)}
                 
              />
            </Col>
            <Col md={4}>
              {/*بخش هشدار ها */}
              <ToDoList
                data={data?.data?.rows?.filter(
                  (issue: Issue) =>
                    issue.flag !== 'error' &&
                    issue.flag !== 'warning' &&
                    issue.flag !== 'info'
                )}
                mode="warning"
                numOfIssue={countSuffix(
                  data?.data?.rows?.find(
                    (issue: Issue) => issue.flag === 'warning'
                  )
                    ?.count
                )}
                title="هشدار"
                tooltip="eererer"
                job_page={searchParams.get('job_page')}
                page_url={searchParams.get('page_url')}
                 
              />
            </Col>
            <Col md={4}>
              {/*بخش اطلاعیه ها */}
              <ToDoList
                data={data?.data?.rows?.filter(
                  (issue: Issue) =>
                    issue.flag !== 'error' &&
                    issue.flag !== 'warning' &&
                    issue.flag !== 'info'
                )}
                numOfIssue={countSuffix(
                  data?.data?.rows?.find(
                    (issue: Issue) => issue.flag === 'info'
                  )?.count
                )}
                mode="info"
                title="اطلاعیه"
                tooltip="eererer"
                job_page={searchParams.get('job_page')}
                page_url={searchParams.get('page_url')}
                 
              />
            </Col>
          </Row>
        </>
      ) : (
        <NoHeaderAgGridSkeleton height="289px" />
      )}
    </div>
  );
};

export default Issues;
const CheckListFounder = (
  name: string,
  mode: ChecklistMode
): ChecklistItem | null => {
  const config = checkListConfig(null) as unknown as ChecklistConfig;
  switch (mode) {
    case 'danger':
      return (
        config.errors.find(
          (column: ChecklistItem) => column.title === name
        ) ?? null
      );
    case 'warning':
      return (
        config.warning.find(
          (column: ChecklistItem) => column.title === name
        ) ?? null
      );
    case 'info':
      return (
        config.info.find(
          (column: ChecklistItem) => column.title === name
        ) ?? null
      );

    default:
      return null;
  }
};

type IssueListItemProps = {
  issue: Issue;
  index: number;
  length: number;
  mode: ChecklistMode;
};

const IssueListItem = ({
  issue,
  index,
  length,
  mode
}: IssueListItemProps) => {
  return (
    <>
      {CheckListFounder(issue.flag, mode) && (
        <>
          <Form.Check
            className="m-3 d-flex align-items-center"
            id={`todoItem-${index}`}
          >
            <Form.Check.Input
              type="checkbox"
              // defaultChecked={item.completed}
              // onChange={e => handleChange(item.id, e.target.checked)}
              className={classNames(
                `mt-0 rounded-circle form-check-input-${mode}`,
                {
                  // 'form-check-line-through': item.completed
                }
              )}
            />
            <Form.Check.Label className="mb-0 mx-3 d-flex justify-content-between w-100">
              <span>{CheckListFounder(issue.flag, mode)?.show_title}</span>
              <span>{issue.count}</span>
            </Form.Check.Label>
          </Form.Check>
          {index !== length && <Divider className="m-0 p-0" />}
        </>
      )}
    </>
  );
};

void IssueListItem;
